<template>
  <div class="abas no-print">
    <div v-for="(aba, index) in abas" :key="index">
      <span
        v-show="ativaAba(aba.aba)"
        @click="controleAbas(aba.tipo, false, true)"
        :class="[
          aba.classe,
          'aba-container',
          { ativo: abaAtiva == aba.tipo },
          {
            'loading-desabilita': loadingResultado && abaAtiva != aba.tipo
          }
        ]"
        >{{ aba.nome }}
        <LineLoading
          color="var(--branco)"
          v-if="loadingResultado && abaAtiva == aba.tipo"
          class="aba-loading"
        />
      </span>
    </div>
  </div>
</template>

<script>
import LinearLoading from "@/components/LinearLoading/LinearLoading.vue";
import LineLoading from "@/components/LineLoading/LineLoading.vue";

export default {
  name: "AbasResultado",
  components: {
    LinearLoading,
    LineLoading
  },
  props: {
    ativaAba: Function,
    controleAbas: Function,
    loadingResultado: Boolean,
    abaAtiva: String
  },
  data() {
    return {
      abas: [
        {
          nome: "IMPOSTO DE IMPORTAÇÃO",
          aba: "IMPOSTO_IMPORTACAO",
          classe: "abaImportacao",
          tipo: "class_importacao"
        },
        {
          nome: "DEFESA COMERCIAL",
          aba: "DEFESA_COMERCIAL",
          classe: "abaDefesa",
          tipo: "defesa_comercial"
        },
        {
          nome: "PREFERÊNCIA TARIFÁRIA",
          aba: "PREFERENCIA_TARIFARIA",
          classe: "abaPreferenciaTarifaria",
          tipo: "preferencia_tarifaria"
        },
        {
          nome: "IMPOSTO DE EXPORTAÇÃO",
          aba: "IMPOSTO_EXPORTACAO",
          classe: "abaExportacao",
          tipo: "exportacao"
        },
        {
          nome: "IPI",
          aba: "IPI",
          classe: "abaIPI",
          tipo: "ipi"
        },
        {
          nome: "PIS/COFINS",
          aba: "PIS_COFINS",
          classe: "abaPISCOFINS",
          tipo: "pis_cofins"
        },
        {
          nome: "CIDE COMBUSTÍVEL",
          aba: "CIDE_COMBUSTIVEL",
          classe: "abaCIDE",
          tipo: "cide_combustivel"
        },
        {
          nome: "ICMS",
          aba: "ICMS",
          classe: "abaICMS",
          tipo: "icms_interno"
        },
        {
          nome: "ICMS ST",
          aba: "ICMS_ST",
          classe: "abaICMSST",
          tipo: "icms_st"
        },
        {
          nome: "ICMS CARGA LÍQUIDA",
          aba: "ICMS_CARGA_LIQUIDA",
          classe: "abaCargaLiquida",
          tipo: "carga_liquida"
        },
        {
          nome: "ICMS ANTECIPAÇÃO",
          aba: "ICMS_ANTECIPACAO_TRIBUTARIA",
          classe: "abaAntecipacao",
          tipo: "antecipacao"
        },
        {
          nome: "ICMS DIFERENCIAL DE ALÍQUOTAS",
          aba: "ICMS_DIFERENCIAL_DE_ALIQUOTAS",
          classe: "abaDifal",
          tipo: "difal"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.loading-desabilita {
  opacity: 0.3 !important;
  background-color: gray !important;
  filter: none !important;
  color: #c4c4c4;
  cursor: not-allowed !important;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
}
.aba-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.aba-loading {
  position: absolute;
  bottom: 7px;
}
</style>
